interface UADataBrand {
  brand: string
  version: string
}

interface NavigatorUAData {
  brands?: UADataBrand[]
  mobile?: boolean
}

export function isVoiceControlBrowserSupported(): boolean {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') {
    return false
  }

  const uaData = (navigator as Navigator & { userAgentData?: NavigatorUAData })
    .userAgentData

  if (!uaData || !Array.isArray(uaData.brands)) return false

  if (uaData.mobile) return false

  const brands = uaData.brands.map(b => b.brand)

  if (!brands.includes('Google Chrome')) return false

  if (brands.includes('Microsoft Edge') || brands.includes('Opera')) {
    return false
  }

  if ('brave' in navigator) return false

  const arcMarker = getComputedStyle(document.documentElement)
    .getPropertyValue('--arc-palette-title')
    .trim()
  if (arcMarker) return false

  return true
}
